import PropTypes from "prop-types";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { createClassNameString } from "@/utils/createClassNameString";

import { Text } from "../../Text";
import { TextTypes } from "../../constants";

import "./styles.scss";

export const EmptyProfileInsurance = ({
  className,
  details,
  onAddButtonClick,
  title,
  ...props
}) => (
  <div className={createClassNameString(["apti-EmptyProfileInsurance", className])} {...props}>
    <div className="apti-EmptyProfileInsurance--left">
      <Text type={TextTypes.heading2}>{title}</Text>
      <Text type={TextTypes.paragraph}>{details}</Text>
    </div>

    {onAddButtonClick && (
      <Button2 className="tw:min-w-40" onPress={onAddButtonClick}>
        Add
      </Button2>
    )}
  </div>
);

EmptyProfileInsurance.propTypes = {
  className: PropTypes.string,
  details: PropTypes.string,
  onAddButtonClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

EmptyProfileInsurance.defaultProps = {
  className: undefined,
  details: "Details",
  title: "Title",
};
